module.exports = __webpack_public_path__ + "img/horn.4850a1c2.svg";